module.exports = require('./dist/loader/browser').default;
